import * as React from "react"
import { App } from "./app"
import { ArticleGW } from "./ArticleGW"
import { BDKalkCore } from "./BDKalkCore"
import { ChoiseControlGW } from "./ChoiseControlGW"
import { ArticleViewGW } from "./ArticleViewGW"

///////////////   ArticleItemGW  ////////////////

export interface ArticleItemVm {
    article: ArticleGW
    core: BDKalkCore
    view: string
}

export interface ArticleItemStates {
    mouseState: string
}

/** ArticleItemGW is the controller class for the articles enlisted within the ArticleViewGW.
 *  Each item holds a reference to an instance of AtricleGW, which may be shared with list items
 *  within the SelectionViewGW and/or the favorites list. Each ArticleItemGW also has a numeric
 *  control object of type ChoiseControlGW which is displayed on the left side of each
 *  item and with which the user can edit the amount for each displayed article.   */
export class ArticleItemGW extends React.Component<ArticleItemVm, ArticleItemStates> {

    constructor(props: ArticleItemVm) {
        super(props)
        this.m_favIsHovered = false
    }

    // Initial state
    state: ArticleItemStates = {
        mouseState: "out"
    }
    
    // Referencing of the amount seting device for this item (which is called by itself on initiation)
    ConnectChoise(choiseCtr: ChoiseControlGW) {
        this.m_choise = choiseCtr
        this.m_clickedArea = "none"
    }

    // Mouse up handler
    onMouseUp() {
        this.setState({ mouseState: "hover" })
        this.m_choise.setState({ hovering: true })
    }

    // Access method - gives a reference to the article displayed by this article item
    GetArticle() {
        return this.props.article
    }

    // A check if this item matches the one presently being typed into (if any)
    GetInputActive() {
        var coreItem = this.props.core.GetInputItemArt()
        if (coreItem == null) {
            return false
        }
        else {
            if (coreItem.GetArticle().GetSelectionLabel() == this.GetArticle().GetSelectionLabel()) {
                return true
            }
            else {
                return false
            }
        }
    }

    // Mouse out handler
    onMouseOut() {
        if (this.GetInputActive() == false) {
            this.setState({ mouseState: "out" })
            this.m_choise.setState({ hovering: false })
            this.m_choise.setState({ plusPressed: false })
            this.m_choise.setState({ minusPressed: false })
        }
        else {
            this.setState({ mouseState: "out" })
        }
    }

    // Mouse over handler
    onMouseOver() {
        this.setState({ mouseState: "hover" })
        this.m_choise.setState({ hovering: true })
    }

    // Mouse down (pressed) handler
    onMouseDown() {
        this.setState({ mouseState: "hover" }) // reusing same graphical behaviour as when hovering the item
    }

    // Mouse click handler
    onClick() {
        const area = this.m_clickedArea
        this.m_clickedArea = "none"
        this.props.core.HandleItemClick(this, area)
    }

    // Mouse click handler
    onClickCenter() {
        this.m_clickedArea = "none"
    }

    // SetLocation is used internally by sub controls to specify where the item has been clicked
    SetLocation(location: string) {
        this.m_clickedArea = location
    }

    // Sets the amount to a new value and forces the affected displays to redraw instantly
    SetAmount(newAmount: number) {
        this.props.article.SetAmount(newAmount)
        this.forceUpdate()
        this.props.core.RedrawTotalSum()
    }

    // Returns true if the article held by this item is the one currently selected within the application
    isSelected() {
        if (this.props.core.GetApp().GetSelectionID() == this.props.article.GetSelectionLabel()) {
            return true
        }
        else {
            return false
        }
    }

    // Handler for when the favorites (star) button of this item is clicked
    onClickFavorites() {
        this.m_clickedArea = "favorites"
    }

    // Rendering the article item as it should be displayed within the articleView
    render() {
        var art = this.props.article

        // Hovering or selecting the item will cause it to render with some visual differences, and hoverstyle (below) holds the final set of characteristics to be rendered
        var hoverstyle: React.CSSProperties = { width: '100%', height: '31px', display: 'flex', flexDirection: 'row', borderTop: '1px solid white', borderBottom: '1px solid white' }
        var hoverstyle_hover: React.CSSProperties = { width: '100%', height: '31px', display: 'flex', flexDirection: 'row', backgroundColor: '#EAf3FF', borderTop: '1px solid #EAf3FF', borderBottom: '1px solid #EAf3FF' }
        var hoverstyle_selected: React.CSSProperties = { width: '100%', height: '31px', display: 'flex', flexDirection: 'row', backgroundColor: '#EAf3FF', borderTop: '1px solid #CAd3dF', borderBottom: '1px solid #CAd3dF' }
        var favStr = "url(images/ItemFavoritesIcon.png)"
        var iconPosX = "-31px"
        var iconPosY = "-31px"
        var extInfoArrowOffset = 7
        var extInfoArrowShow = false // If or not the ext info dropdown arrow should be displayed

        // Picking the favorites star image position
        if (this.state.mouseState == "hover") {
            iconPosY = "0px"
        }

        if (this.props.article.GetSelectionLabel() == this.props.core.GetApp().GetSelectionID()) {
            iconPosY = "0px"
        }

        if (this.props.core.FavoritesFind(this.props.article.GetSelectionLabel())) {
            iconPosX = "0px"

            if (this.props.view == "favorites") {
                // iconPosX = "-62px"

                if (this.m_favIsHovered == true) {
                    iconPosX = "-124px"
                }
            }
        }
        
        // When the selected article is being hovered, the arrow to collapse/expand the extended info will light up a bit
        if (this.state.mouseState == "hover") {
            hoverstyle = hoverstyle_hover
            extInfoArrowOffset += 68
        }

        // Only the selected article can have an arrow to hide/show the extended info
        if (this.isSelected()) {
            this.props.core.ConnectSelectedArticleItem(this)
            hoverstyle = hoverstyle_selected
            extInfoArrowShow = true
        }

        // If ext info is shown, the arrow will point upward as to show it can be hidden by clicking the article again
        if (this.props.core.GetApp().state.ExtInfoUp == true) {
            extInfoArrowOffset += 34
        }

        // turns the offset into a string that will be used to position the background image
        const bgPositionFav = iconPosX + " " + iconPosY 
        const bgPosition = "0px -" + extInfoArrowOffset.toString() + "px"

        var isVisible = (extInfoArrowShow == true) ? "visible" : "hidden"
        var extArrowStyle: React.CSSProperties = { width: "25px", height: "20px", backgroundImage: "url(images/UtvidetInfoLocalArrow.png)", backgroundPosition: bgPosition, visibility: isVisible, position: "relative", top: "4px", left: "0px" }
        
        // The following is for performing selections using up and down keys acroll pages of search results, the last and first article items will give their references here.
        var arts = this.props.core.GetRenderedArticleGroup()
        if ((arts != null) && (this.props.core.GetRollIn() != 0)) {
            if (arts.length > 0) {
                if (arts[arts.length - 1].GetSelectionLabel() == this.GetArticle().GetSelectionLabel()) {
                    // this is the last item among the displayed items
                    this.props.core.SetArticleItemLast(this)
                    setTimeout(this.props.core.PerformRollIn.bind(this.props.core), 20)
                }

                if (arts[0].GetSelectionLabel() == this.GetArticle().GetSelectionLabel()) {
                    // this is the first item among the displayed items
                    this.props.core.SetArticleItemFirst(this)
                }
            }
        }
        
        return <div onMouseOut={this.onMouseOut.bind(this)}
            onMouseOver={this.onMouseOver.bind(this)}
            onMouseDown={this.onMouseDown.bind(this)}
            onMouseUp={this.onMouseUp.bind(this)}
            onClick={this.onClick.bind(this)}
            id={this.isSelected() ? "isCurrentlySelected" : undefined}
            style={hoverstyle}>

            {/* Margin left */}
            <div style={{ width: "5px" }} >
            </div>

            {/* Ext Info arrowdown area */}
            <div onClick={this.onClickCenter.bind(this)} style={extArrowStyle} >
            </div>

            {/* Margin */}
            <div style={{ width: "5px" }} >
            </div>

            {/* Numeric control area */}
            <div style={{ width: "120px" }} >
                <ChoiseControlGW core={this.props.core} articleItem={this} />
            </div>
            
            {/* Central dynamic columns area */}
            <div onClick={this.onClickCenter.bind(this)} style={{ width: "calc(100% - 187px)", display: 'flex', flexDirection: 'row' }} >
                <div style={{ width: "1%" }}></div>
                <div style={{ width: "9%" }}>{art.GetUnit()}</div>
                <div style={{ width: "64%", display:"plex", direction:"column"}}>
                    <div style={{position:"relative", top:"-2px"}}>{art.GetDescription()}</div>
                    <div style={{ position: "relative", top: "-2px" }}>{art.GetDescription2()}</div>
                </div>
                <div style={{ width: "13%" }}>{art.GetIdentifier()}</div>
                <div style={{ width: "calc(12% - 8px)", textAlign: "right" }}>{this.props.core.GetArticlePrizeString(art)}</div>
                <div style={{ width: "calc(12% - 8px)", textAlign: "right" }}>{art.GetSumString(this.props.core.GetPriceRadio(), this.props.core.GetPriceFlags())}</div>
                <div style={{ width: "calc(1% + 8px)" }}></div>
            </div>

            {/* Favorites star area */}
            <div
                style={{
                    width: "32px",
                    cursor: "pointer",
                    backgroundImage: favStr,
                    backgroundPosition: bgPositionFav
                }}
                onClick={this.onClickFavorites.bind(this)}
                onMouseEnter={this.OnEnterFavorites.bind(this)}
                onMouseLeave={this.OnExitFavorites.bind(this)}>
            </div>
        </div>
    }

    // Handler for mouse entering over the favorites (star) icon.
    OnEnterFavorites() {
        this.m_favIsHovered = true
        this.forceUpdate()
    }

    // Handler for mouse exting the favorites (star) icon.
    OnExitFavorites() {
        this.m_favIsHovered = false
        this.forceUpdate()
    }

    m_choise: ChoiseControlGW  // The numerical amount seting control shown to the left of the item
    m_clickedArea: string      // This is set by the various controls being clicked, then reset to "none" 
                               // in onClick for the entire item, after the click has been handled

    m_favIsHovered : boolean   // Flag telling if the mouse is or is not hovering the favorites icon.
}


// WEBPACK FOOTER //
// ./client/view/ArticleItemGW.tsx